export type SensitiveSemantic = 'contract' | 'profit' | 'changeorder' | 'settlement' | 'budget' | 'subcontract';

const SEMANTIC_PERMISSION_MAP: Record<SensitiveSemantic, { view: string; edit: string; manage: string }> = {
  contract: {
    view: 'sensitive:contract:view',
    edit: 'sensitive:contract:edit',
    manage: 'sensitive:contract:manage',
  },
  profit: {
    view: 'sensitive:profit:view',
    edit: 'sensitive:profit:edit',
    manage: 'sensitive:profit:manage',
  },
  changeorder: {
    view: 'sensitive:changeorder:view',
    edit: 'sensitive:changeorder:edit',
    manage: 'sensitive:changeorder:manage',
  },
  settlement: {
    view: 'sensitive:settlement:view',
    edit: 'sensitive:settlement:edit',
    manage: 'sensitive:settlement:manage',
  },
  budget: {
    view: 'sensitive:budget:view',
    edit: 'sensitive:budget:edit',
    manage: 'sensitive:budget:manage',
  },
  subcontract: {
    view: 'sensitive:subcontract:view',
    edit: 'sensitive:subcontract:edit',
    manage: 'sensitive:subcontract:manage',
  },
};

export function hasSensitivePermission(
  checkPermission: (permission: string) => boolean,
  semantic: SensitiveSemantic,
  action: 'view' | 'edit' = 'view'
): boolean {
  const mapping = SEMANTIC_PERMISSION_MAP[semantic];
  if (!mapping) {
    return false;
  }

  return checkPermission(mapping.manage) || checkPermission(mapping[action]);
}
